
export abstract class  BaseGateReportListComponent {

  requestBody: GateReport = {
		date:null,
		search: "",
		pageSize: 10,
		pageNumber: 1,
		sort: "createdAt",
		sortType: "ASC",
    columns:[],
	};
  constructor(){

  }
  abstract updateTable();
  getCurrentPage(event: any) {
    if (event && Object.keys(event).length) {
      console.log("filter should not be null");
      this.requestBody.filterOptions = event;
    } else {
      console.log("filter should be null");
      this.requestBody.filterOptions = {};
    }

    this.updateTable();
  }
  async paginate(event: any) {
    this.requestBody = {
      ...this.requestBody,
      pageNumber: event.pageIndex+1,
      pageSize: event.pageSize
    };
    this.updateTable();
  }
  async searchChange(event: any) {
    if (event) {
      this.requestBody = {
        ...this.requestBody,
        search: event
      };
    } else {
      this.requestBody.search = undefined;
    }
    await this.updateTable();
  }
  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody={
        ...this.requestBody,
        sort: "createdAt",
      }
    } else {
      this.requestBody={
        ...this.requestBody,
        sort:event.active,
        sortType:event.direction,
      }
    await this.updateTable();
  }
}


}
interface GateReport{
  date?: { gte: string, lt: string } | null,
  search?: string,
  pageSize?: number,
  pageNumber?: number,
  sort?: string,
  sortType?: 'ASC' | 'DESC',
  columns?: Array<string>,
  with?: Array<any>
  filterOptions?: any
}
